import { Query, readItems } from "@directus/sdk";
import { GaripalliDirectusClient } from "../directus/client";
import { Partner } from "../directus/collections";
import { Schema } from "../directus/schema";

export async function fetchPartners(
  client: GaripalliDirectusClient,
  query?: Query<Schema, Partner> | undefined
) {
  return client.request<Partner[]>(readItems("partners", query));
}
